import {StateType} from "../store/store";

export const loadState = () => {
  try {
      const serializedState = localStorage.getItem("vidcom");
      if (serializedState === null) {
          return undefined;
      }
      return JSON.parse(serializedState);
  } catch (err) {
      return undefined;
  }
}

export const saveState = (state: StateType) => {
  try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem("vidcom", serializedState);
  } catch (err) {
      console.log(`errors from localstorage.js -: ${err}`)
  }
}